module.exports = __webpack_public_path__ + "static/award6-f0dfd2596b4eeb8c2ef69ddf9300140d.png";